import { attr } from "@ember-data/model";
import dayjs from "dayjs";
import {
  validateDate,
  validateInclusion,
  validatePresence
} from "ember-changeset-validations/validators";
import type IntlService from "ember-intl/services/intl";
import JournalEvent from "parog-web/models/journal-event";
import tWithDefault from "parog-web/utils/t-with-default";

//---- Automatically generated, don't update this part ----

type StatusStringEnum = "in_progress" | "cancelled" | "validated";

/**
 * Created for the patients who starting the trial period and when it is finished
 */
export default class TlsTrialPeriodJournalEvent extends JournalEvent {
  static override type = "tls-trial-period-journal-event";

  @attr("string") declare status: StatusStringEnum;

  @attr("date") declare startedDate: Date;

  static override validations(intl: IntlService) {
    return {
      status: [
        validatePresence({
          presence: true,
          description: intl.t(
            "validations.tls-trial-period-journal-event.status"
          )
        }),
        validateInclusion({
          list: ["in_progress", "cancelled", "validated"],
          description: intl.t(
            "validations.tls-trial-period-journal-event.status"
          )
        })
      ],
      startedDate: validatePresence({
        presence: true,
        description: intl.t(
          "validations.tls-trial-period-journal-event.started-date"
        )
      }),
      occurredAt: [
        validatePresence({
          presence: true,
          description: tWithDefault(
            intl,
            "validations.tls-trial-period-journal-event.occurred-at",
            "La date"
          )
        }),
        validateDate({
          message:
            "Cette donnée ne peut être déclarée avant 1900. Veuillez modifier la date",
          onOrAfter: new Date("01/01/1900")
        }),
        validateDate({
          message:
            "Cette donnée ne peut être déclarée dans le futur. Veuillez modifier la date",
          onOrBefore: dayjs().endOf("day").toDate()
        })
      ]
    };
  }

  //---- End of generated code ----
}

// DO NOT DELETE: this is how TypeScript knows how to look up your models.
declare module "ember-data/types/registries/model" {
  export default interface ModelRegistry {
    "tls-trial-period-journal-event": TlsTrialPeriodJournalEvent;
  }
}
